// /src/pages/parallel/ParallelRegionPage.js
import { useNavigate } from "react-router-dom";
import { useParallelPersona } from "../../context/ParallelPersonaContext";
import { useState } from "react";
import Header from "../../components/Header";
import "../../styles/ParallelRegionPage.css";

const ParallelRegionPage = () => {
  const { setLocation } = useParallelPersona();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);

  const handleNext = () => {
    if (selectedOption === "both") {
      setLocation("Both");
    } else if (selectedOption === "england") {
      setLocation("England");
    } else if (selectedOption === "scotland") {
      setLocation("Scotland");
    }
    navigate("/parallel/ethnicity");
  };

  return (
    <div className="region-page">
      <Header />
      <h2 className="page-title">Select Region</h2>
      <p>The app found these regions in the dataset</p>
      <table className="region-table">
        <thead>
          <tr>
            <th>Value</th>
            <th>No of Responses</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>England</td>
            <td>594</td>
          </tr>
          <tr>
            <td>Scotland</td>
            <td>284</td>
          </tr>
        </tbody>
      </table>
      <p>
        As the number of responses for this survey are small for Scotland, we
        suggest going ahead for either both regions together, or just England,
        for better results.
      </p>
      <div className="region-options">
        <label>
          <input
            type="radio"
            name="region"
            value="both"
            onChange={() => setSelectedOption("both")}
          />{" "}
          Go ahead with both regions together
        </label>
        <label>
          <input
            type="radio"
            name="region"
            value="england"
            onChange={() => setSelectedOption("england")}
          />{" "}
          Go ahead with England only
        </label>
        <label>
          <input
            type="radio"
            name="region"
            value="scotland"
            onChange={() => setSelectedOption("scotland")}
          />{" "}
          Go ahead with Scotland only
        </label>
      </div>
      <div className="navigation-buttons">
        <button
          className="back-button"
          onClick={() => navigate("/parallel/upload")}
        >
          Back
        </button>
        <button
          className="next-button"
          onClick={handleNext}
          disabled={!selectedOption}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ParallelRegionPage;
